export default "__VITE_ASSET__DgiVPxnC__"